import api from '../index';

const baseUrl = '/payment';

export const createPaymentApi = (payment) => {
  return api({
    method: 'post',
    url: `${baseUrl}/create-payment`,
    data: payment,
  });
};

export const getPaymentsByRoApi = (roId) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-all-payments/${roId}`,
  });
};

export const getApprovedJobsApi = (roId) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-approved-jobs/${roId}`,
  });
};

export const getPaymentsApi = () => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-payments`,
  });
};

export const addExtraAmountApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/add-extra-amount`,
    data,
  });
};

export const createPaymentIntent = (data) => {
  return api({
    method: 'post',
    url: '/users/create-payment-intent',
    data,
  });
};

export const getCreditAmount = (tenantId) => {
  return api({
    method: 'get',
    url: `/users/get-credit-amount/${tenantId}`,
  });
};

export const updatePurchasedCredits = (data) => {
  return api({
    method: 'post',
    url: '/users/update-purchased-credits',
    data,
  });
};

export const sendPaymentLinkApi = (data) => {
  return api({
    method: 'post',
    data,
    url: `${baseUrl}/send-payment-link`,
  });
};

export const sharePaymentLinkApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/share-payment-link`,
    data,
  });
};

export const getPaymentTerminalDetailApi = (id) => {
  return api({
    method: 'get',
    url: `payment-terminal/${id}`,
  });
};

export const saveTorquePaymentAdvanceSettingsApi = (userId, data) => {
  return api({
    method: 'post',
    url: 'payment-terminal/settings',
    data,
  });
};

// export const resetTerminalApi = async (data) => {
//   return api({
//     method: 'post',
//     url: `${process.env.REACT_APP_PAYMENT_BACKEND_URL}/reset-terminal`,
//     data,
//   });
// };
export const resetTerminalApi = async (data) => {
  try {
    const response = await api({
      method: 'post',
      url: `${process.env.REACT_APP_PAYMENT_BACKEND_URL}/reset-terminal`,
      data,
    });
    return response;
  } catch (error) {
    console.error('Error in resetTerminalApi:', error);
    return error;
  }
};

export const sendAcRecievable = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/account-receivable`,
    data: data,
  });
};

export const getAcRecievable = (query) => {
  return api({
    method: 'get',
    url: `${baseUrl}/account-receivable?${query}`,
  });
};

export const payAcRecievable = (requestBody) => {
  return api({
    method: 'post',
    url: `${baseUrl}/account-receivable-payments`,
    data: requestBody,
  });
};

export const addEditNotes = (requestBody) => {
  return api({
    method: 'post',
    url: `${baseUrl}//add-notes`,
    data: requestBody,
  });
};
